import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-expansion-panel-dark], [xpoExpansionPanelDark] ',
  host: {
    class: 'xpo-ExpansionPanelDark--wrap',
  },
})
export class XpoExpansionPanelDark {}
